/**
 * Estilos compartilhados para react-select (alinhados ao Bootstrap form-control).
 * Altura igual ao select/input nativo: padding 0.375rem 0.75rem + line-height 1.5 + border = ~38px.
 */
const controlPaddingY = '0.375rem';
const controlPaddingX = '0.75rem';

export const formSelectStyles = {
    control: (base, state) => {
        const error = state.selectProps?.error;
        return {
            ...base,
            display: 'flex',
            minHeight: 38,
            height: 'auto',
            minWidth: 180,
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.5,
            color: '#495057',
            backgroundColor: state.isDisabled ? '#e9ecef' : '#FFFFFF',
            border: error ? '1px solid #fc0808' : '1px solid #ced4da',
            borderRadius: '0.25rem',
            boxShadow: 'none',
            outline: 'none',
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            padding: 0,
            alignItems: 'flex-start',
        };
    },
    valueContainer: (base, state) => ({
        ...base,
        padding: `${controlPaddingY} ${controlPaddingX}`,
        cursor: 'pointer',
        flexWrap: 'wrap',
        alignItems: 'center',
        rowGap: '2px',
        flex: '1 1 0%',
        minWidth: 0,
    }),
    singleValue: (base) => ({
        ...base,
        color: '#495057',
        cursor: 'pointer',
        lineHeight: 1.5,
        whiteSpace: 'normal',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
        overflow: 'visible',
        textOverflow: 'clip',
        position: 'relative',
        transform: 'none',
        top: 'auto',
        marginTop: 0,
        marginBottom: 0,
        maxWidth: '100%',
        width: '100%',
    }),
    /* Corrige corte da primeira letra ao pesquisar (grid 0 min-content colapsa o input). */
    input: (base) => ({
        ...base,
        color: '#495057',
        gridTemplateColumns: '0fr 1fr',
        cursor: 'pointer',
        margin: 0,
        padding: 0,
    }),
    placeholder: (base) => ({
        ...base,
        color: '#6c757d',
        cursor: 'pointer',
        whiteSpace: 'normal',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
        maxWidth: '100%',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    indicatorsContainer: (base) => ({
        ...base,
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'flex-start',
        height: 'auto',
        minHeight: 36,
        flexShrink: 0,
        paddingTop: 2,
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        padding: '0 8px',
        color: '#495057',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'auto',
        minHeight: 36,
        flexShrink: 0,
    }),
    clearIndicator: (base, state) => ({
        ...base,
        padding: '0 8px',
        color: '#495057',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'auto',
        minHeight: 36,
    }),
    menu: (base) => ({
        ...base,
        border: '1px solid #ced4da',
        borderRadius: '0.25rem',
        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
        minWidth: 180,
        width: 'max-content',
        maxWidth: 'min(90vw, 500px)',
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: 300,
    }),
    option: (base, { isFocused, isSelected }) => ({
        ...base,
        fontSize: '1rem',
        padding: '0.375rem 0.75rem',
        backgroundColor: isSelected ? '#0d6efd' : isFocused ? '#e9ecef' : '#FFFFFF',
        color: isSelected ? '#fff' : '#495057',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

/** Estilo do control com largura horizontal fixa (= 100% do container): o texto quebra e a altura cresce para baixo. */
export const formSelectControlFullWidth = (base, state) => ({
    ...formSelectStyles.control(base, state),
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
});
